import MyStoresOnShelfAvailability from "./MyStoresOnShelfAvailability";
export default MyStoresOnShelfAvailability;
